<template>
	<v-row justify="center">
		<v-col cols="10" lg="4" md="5" sm="6">
			<v-card class="mx-auto mt-3">
				<v-card-title v-if="!admin" class="primary--text">Login</v-card-title>
				<v-card-title v-else class="primary--text">Admin Login</v-card-title>
				<v-card-text class="px-8">
					<v-form ref="form" v-model="valid" lazy-validation>
						<v-alert v-model="error" color="red lighten-2" class="text-caption" icon="warning">
							<translate>Email or password incorrect.</translate>
						</v-alert>
						<v-alert v-model="afterRegistration" color="alert" type="success" class="text-caption">
							<translate>Registration Successful! You can now log in into your account.</translate>
						</v-alert>
						<v-text-field
							required
							v-model="email"
							label="Email"
							prepend-inner-icon="mdi-account-circle"
							:rules="emailRules"
							filled
							validate-on-blur
							@keyup.enter.native="login"
							placeholder=" "
						/>
						<v-text-field
							:type="showPassword ? 'text' : 'password'"
							:label="$gettext('Password')"
							prepend-inner-icon="mdi-lock"
							:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
							@click:append="showPassword = !showPassword"
							v-model="password"
							required
							:rules="passwordRules"
							filled
							validate-on-blur
							@keyup.enter.native="login"
							placeholder=" "
						/>
						<v-checkbox
							v-model="remember"
							color="primary"
							:label="$gettext('Remember me')"
							class="mt-0 py-0"
							hide-details
							dense
						/>
						<v-row no-gutters>
							<v-spacer></v-spacer>
							<a v-translate @click="requestReset">Forgot your password?</a>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="pa-3">
					<v-spacer></v-spacer>
					<v-btn depressed color="primary" @click="login()" :loading="loading">
						<translate>Login</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "login-form",
	props: {
		afterRegistration: {
			default: false
		},
		admin: {
			default: false
		}
	},
	data: () => ({
		loading: false,
		error: false,
		valid: true,
		showPassword: false,
		email: "",
		password: "",
		remember: false
	}),
	computed: {
		passwordRules() {
			return [
				v => !!v || this.$gettext("Password is required"),
				v =>
					(v && v.length >= 8) ||
					this.$gettext("Password must have at least 8 characters")
			];
		},
		emailRules() {
			return [
				v => !!v || this.$gettext("Email is required"),
				v => /.+@.+\..+/.test(v) || this.$gettext("Email must be valid")
			];
		}
	},
	methods: {
		validate() {
			return this.$refs.form.validate();
		},
		login() {
			if (this.validate()) {
				this.loading = true;
				this.error = false;
				const formData = new FormData();
				formData.append("email", this.email);
				formData.append("pwd", this.password);
				formData.append("remember", this.remember);
				var data = {};
				data["form"] = formData;
				data["admin"] = this.admin;
				this.$store
					.dispatch("LOGIN", data)
					.then(response => {
						console.log(response);
						if (response.result === "multiple_users") {
							console.log("mutiple users");
						} else if (response.result === "error") {
							console.log("error");
							this.error = true;
						} else if (response.result === "logged") {
							this.$store.dispatch("UPDATE_USER", response.user);
							if (this.admin) this.$router.push("/admin/dashboard");
							else if(this.$store.getters.isExternalEntity) this.$router.push("/settings");
							else {
								if(this.$store.getters.hasRole('manager') && !this.$store.getters.hasAnyModule) this.$router.push({name: "modules"});
								else this.$router.push({name: "home"});
							}
						}
						this.loading = false;
					})
					.catch(error => {
						console.log(error);
						this.loading = false;
					});
			}
		},
		requestReset() {
			this.$router.push({
				name: "request-reset"
			});
		}
	}
};
</script>

<style scoped>
>>> .v-input--selection-controls .v-input__slot > .v-label {
		font-size: 13px;
}
</style>